import { render, staticRenderFns } from "./personInfoCard.vue?vue&type=template&id=792f2711&scoped=true"
import script from "./personInfoCard.vue?vue&type=script&lang=js"
export * from "./personInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792f2711",
  null
  
)

export default component.exports